export const bgModal =
  'fixed inset-0 bg-neutral-500/25 backdrop-blur-xs dark:bg-neutral-400/30 transition-opacity'

export const iconClassModal = 'h-6 w-6 text-primary-600 dark:text-primary-300'

export const bgFooterModal =
  'bg-neutral-200 rounded-b-lg dark:bg-neutral-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse'

export const closeButtonModal =
  'inline-flex w-full justify-center rounded-md bg-primary-600 dark:bg-primary-900 px-3 py-2 text-sm font-semibold text-white dark:text-neutral-300 shadow-xs hover:bg-primary-500 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600'
